import { heavy, normal, small } from 'components/calls/styles/fonts';
import styled from 'styled-components';
import { getImageUrl } from 'utils';

export const SelectContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin-bottom: 22px;
  background-color: var(--white);
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SelectLabel = styled.label`
  ${small};
  ${heavy};
  display: inline-block;
  height: 12px;
  margin-bottom: 6px;
`;

export const Select = styled.select`
  ${normal};
  ${heavy};
  appearance: none;
  width: 100%;
  height: 40px;
  padding: 10px 36px 10px 16px;
  border-radius: 4px;
  border: solid 1px var(--navy-200);
  background-color: var(--white);
  background-image: ${getImageUrl('/icons/ic-input-arrow-down.svg')};
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
`;
